// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Design Tokens - Interactive State Colors */
.vnsc-root {
  --vnsc-state-hover: var(--vnsc-bg-hover);
  --vnsc-state-active: var(--vnsc-bg-active);
  --vnsc-state-pressed: rgba(255, 255, 255, 0.12);
  --vnsc-state-dragging: rgba(59, 130, 246, 0.08);
  --vnsc-state-loading: var(--vnsc-bg-disabled);
  --vnsc-state-selected: var(--vnsc-bg-selected);
  --vnsc-state-focus-within: var(--vnsc-bg-focus);
}

.vnsc-root[data-chart-mode="light"] {
  --vnsc-state-pressed: rgba(0, 0, 0, 0.12);
  --vnsc-state-dragging: rgba(37, 99, 235, 0.08);
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/states.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,wCAAwC;EACxC,0CAA0C;EAC1C,+CAA+C;EAC/C,+CAA+C;EAC/C,6CAA6C;EAC7C,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,yCAAyC;EACzC,8CAA8C;AAChD","sourcesContent":["/* Design Tokens - Interactive State Colors */\r\n.vnsc-root {\r\n  --vnsc-state-hover: var(--vnsc-bg-hover);\r\n  --vnsc-state-active: var(--vnsc-bg-active);\r\n  --vnsc-state-pressed: rgba(255, 255, 255, 0.12);\r\n  --vnsc-state-dragging: rgba(59, 130, 246, 0.08);\r\n  --vnsc-state-loading: var(--vnsc-bg-disabled);\r\n  --vnsc-state-selected: var(--vnsc-bg-selected);\r\n  --vnsc-state-focus-within: var(--vnsc-bg-focus);\r\n}\r\n\r\n.vnsc-root[data-chart-mode=\"light\"] {\r\n  --vnsc-state-pressed: rgba(0, 0, 0, 0.12);\r\n  --vnsc-state-dragging: rgba(37, 99, 235, 0.08);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
